import React, { SVGProps } from 'react'

const SvgPlayStation = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg viewBox='0 0 24 24' className='svg-icon' {...props}>
            <g clipPath='url(#clip0_1824_120936)'>
                <path
                    d='M10.2019 1.2334V19.1419L14.2542 20.4297V5.40672C14.2542 4.70471 14.5689 4.23509 15.0772 4.39486C15.7357 4.57884 15.8664 5.22759 15.8664 5.9296V11.9281C18.3936 13.1482 20.3786 11.9281 20.3786 8.70859C20.3786 5.48903 19.2167 3.93976 15.7841 2.76329C14.4333 2.3082 11.9255 1.55293 10.2019 1.2334Z'
                    fill='#E4E4E7'
                />
                <path
                    opacity='0.4'
                    d='M15.0239 17.8104L21.5405 15.4914C22.2812 15.2251 22.3926 14.8523 21.7923 14.6538C21.1919 14.4553 20.1074 14.5134 19.3667 14.7797L15.0239 16.3096V13.8743L15.2757 13.7872C15.2757 13.7872 16.5296 13.3466 18.2919 13.1481C20.059 12.9545 22.2183 13.1772 23.9128 13.8162C25.8252 14.4214 26.0382 15.3074 25.5541 15.9223C25.0699 16.5371 23.8789 16.9729 23.8789 16.9729L15.0239 20.1537V17.8056V17.8104Z'
                    fill='#E4E4E7'
                />
                <path
                    opacity='0.4'
                    d='M2.77029 17.5633C0.809508 17.0114 0.48029 15.8591 1.37596 15.1958C2.20384 14.581 3.6127 14.121 3.6127 14.121L9.42244 12.0586V14.4115L5.24427 15.9075C4.50353 16.1738 4.39218 16.5466 4.99252 16.7451C5.59285 16.9388 6.68218 16.8855 7.42292 16.6192L9.42728 15.893V17.999C9.3014 18.0233 9.161 18.0426 9.02544 18.0668C7.02108 18.3912 4.886 18.2556 2.77998 17.5633'
                    fill='#E4E4E7'
                />
            </g>
            <defs>
                <clipPath id='clip0_1824_120936'>
                    <rect width='24.8995' height='20' fill='white' transform='translate(0.901489 0.749023)' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default SvgPlayStation
